import { useEffect } from 'react'

import { latestAuthStateWithAccessToken$ } from '../../../auth/state'
import { actions, UseCartGetReducer } from '../useCartGetReducer'

export const useAuthActions = ({ reducer }: { reducer: UseCartGetReducer }): void => {
  const [state, dispatch] = reducer

  // dispatch session actions
  useEffect(() => {
    if (state.type !== 'none') {
      return
    }
    const subscription = latestAuthStateWithAccessToken$.subscribe({
      next: (authState) =>
        dispatch(authState.isAuthenticated ? actions.loggedIn() : actions.loggedOut()),
      error: () => dispatch(actions.loggedOut()),
    })
    return () => subscription.unsubscribe()
  }, [dispatch, state.type])
}
